import { InformacionAcademicaData } from 'components/InformacionAcademica';
import { UserData } from 'components/Sidebar/Sidebar_Principal';
import Cargando from 'components/Varios/Cargando';
import ModalCargando from 'components/Varios/ModalCargando';
import React, { useEffect, useMemo, useRef, useState } from 'react'
import { Button } from 'react-bootstrap';

//Bootstrap
import { Modal, ModalHeader, ModalBody, Row, Col } from "reactstrap";
import { authenticationService } from 'services/authentication.service';
import { ObtenerInformacionTitulosRegistrados, ParseInformacionTableTitulos } from './FuncionesTitulosRegistrados';
import TableTitulosRegistrados from './TableTitulosRegistrados';

//Types
import { InformacionSenescytTitulos, PropsModalTitulosRegistrados, RowsTitulosRegistrados } from './TypesInformacionAcademica'

const ModalTitulosRegistradosSenescyt = (props: PropsModalTitulosRegistrados) => {

    const [mensajeError, setmensajeError] = useState<string>("")
    const [TitulosPersona, setTitulosPersona] = useState<InformacionSenescytTitulos[]>([])
    const [TitulosGuardados, setTitulosGuardados] = useState<InformacionAcademicaData[]>([])
    const [terminoLlamar, setterminoLlamar] = useState<boolean>(false)
    const [loading, setloading] = useState<boolean>(false)


    useEffect(() => {
        const { nivel } = props.informacion;
        if (nivel) {
            ObtenerInformacion(props.informacion.nivel)
        }
    }, [props.informacion.nivel])

    useEffect(() => {

        if (props.informacionGuardada && props.informacionGuardada.length > 0) {
            setTitulosGuardados(props.informacionGuardada)
        }

    }, [props.informacionGuardada])

    
    

    const dataTable: RowsTitulosRegistrados[] = useMemo(() => {
        return ParseInformacionTableTitulos(TitulosPersona,TitulosGuardados)
    }, [TitulosPersona,TitulosGuardados])

    function CerrarModal() {
        setmensajeError("")
        setTitulosPersona([])
        setterminoLlamar(false)
        setloading(false)
        if (typeof (props.onClose) === "function") {
            props.onClose()
        }
    }

    async function ObtenerInformacion(tipoNivelAcademico: string) {
        setloading(true)
        var infoUser: UserData = authenticationService.currentUserValue;
        var respuesta = await ObtenerInformacionTitulosRegistrados(tipoNivelAcademico, infoUser)
        if (respuesta.status !== 200 && respuesta.errorMessage) {
            setmensajeError(respuesta.errorMessage);
        }
        setTitulosPersona(respuesta.datos);
        setterminoLlamar(true);
        setloading(false);
    }

    function HandlenRegistroSeleccionado(nregistro: string, titulos: InformacionSenescytTitulos[]) {
        var TituloEscogido = titulos.find((infoTitulo, indiceTitulo) => {
            return infoTitulo.numeroRegistro === nregistro;
        })

        if (TituloEscogido && typeof (props.handleRegistroSeleccionado) === "function") {
            props.handleRegistroSeleccionado(TituloEscogido);
            CerrarModal()
        }
        else {
            setmensajeError("No ha sido posible llenar la información con ese Título")
        }
    }

    if (loading) {
        return (
            <ModalCargando
                show={true}
                onClose={() => console.log()}
                size="sm"
                textoCargando='Cargando Tabla'
            />
        )
    }



    return (
        <Modal
            isOpen={props.show}
            scrollable={true}
            size={props.size}
            fullscreen={props.fullscreen}
            centered={true}
            onClosed={props.onClose}
        >

            <ModalHeader close={<button onClick={() => CerrarModal()}> X </button>} >

            </ModalHeader>
            <ModalBody>
                <Row className="justify-content-md-start justify-content-sm-center">
                    <Col className=" mb-3 no-padding text-center text-md-right" md={{ offset: 0, size: 7 }} lg={{ offset: 0, size: 5 }} sm={12}>
                        <div className="titulos_modal ">Títulos SENESCYT - {props.informacion.nivel}</div>
                    </Col>
                </Row>

                {
                    dataTable.length !== 0 &&
                    (
                        <Row>
                            <Col>
                                <TableTitulosRegistrados
                                    data={dataTable}
                                    handleRegistro={(nregistro: string) => HandlenRegistroSeleccionado(nregistro, TitulosPersona)}
                                />
                            </Col>
                        </Row>
                    )
                }
                {
                    mensajeError &&
                    <div>
                        {mensajeError}
                    </div>
                }
                {
                    terminoLlamar && dataTable.length === 0 &&
                    <React.Fragment>
                        <Row className="justify-content-center">
                            <Col className="text-align-center" xs={12} md={12}>
                                <div className="mensajeVacioTitulos">No hay información sobre títulos de ese nivel registrados en SENESCYT. Favor llenar manualmente su información.</div>
                            </Col>
                        </Row>
                        <Row className="justify-content-center">
                            <Col className="text-align-center" xs={12} md={6} lg={2}>
                                <Button className="btnEspolPrimary butonAgregarTitulo" type="button" onClick={() => CerrarModal()}>Cancelar</Button>
                            </Col>
                        </Row>
                    </React.Fragment>

                }

            </ModalBody>

        </Modal>
    )
}

export default ModalTitulosRegistradosSenescyt